/**
 * @file Contém as constantes da aplicacao
 */
import alert from "./alert";
import ato from "./ato";
import documentos from "./documentos";
import indices from "./indices";
import pesquisa from "./pesquisa";
import sistema from "./sistema";
import sumario from "./sumario";
import usuario from "./usuario";

const constantes = Object.freeze({
    LOCALE: 'pt-BR',
    BASE_URL: window.location.protocol+'//'+window.location.host,
    alert,
    ato,
    documentos,
    indices,
    pesquisa,
    sistema,
    sumario,
    usuario
});

export default constantes;
